<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>{{ utilsService.userIsAdmin() && isAdminView ? 'Global User Space' : 'User Space' }}</h2>
      <div class="close" (click)="cancelUserSpaceModal()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="loading" [ngClass]="this.isLoading ? 'active' : ''">
        <div></div>
      </div>
      <div class="fields__container">
        <form *ngIf="utilsService.userIsAdmin() && isAdminView" autocomplete="off" name="ngTerrainsFormAdmin"
          #ngFormAdmin="ngForm" id="terrainsFormAdmin" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <!-- Admin combined chart here -->
              <div>
                <label> All User Spaces: {{ allUserSpacesAvailable?.value }}GB</label>
              </div>
              <div>
                <canvas #allUserSpacesChart width="1320" height="250" backgroundColor="white"></canvas>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button class="gray" (click)="cancelUserSpaceModal()">Ok</button>
          </div>
        </form>
        <form *ngIf="!isAdminView" autocomplete="off" name="ngTerrainsFormUser" #ngForm="ngForm" id="terrainsForm"
          class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <!-- Regular user charts here -->
              <div>
                <label>Total Available Space: {{ totalUserSpaceAvailable?.value ?? 0 }}GB</label>
              </div>
              <div>
                <canvas #userSpaceChart width="1320" height="250" backgroundColor="white"></canvas>
              </div>
              <div>
                <label>Calculation Database Available Space: {{ calculationDatabaseSpaceAvailable?.value ?? 0 }}GB</label>
              </div>
              <div>
                <canvas #calculationDatabaseChart width="1320" height="250" backgroundColor="white"></canvas>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button class="gray" (click)="cancelUserSpaceModal()">Ok</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
